import React, { useState } from 'react';

interface PainPointCardProps {
  point: {
    Area: string;
    PainPoint: string;
    Remediation: string;
  };
  index: number;
}

const PainPointCard: React.FC<PainPointCardProps> = ({ point, index }) => {
  const [isRemediationExpanded, setIsRemediationExpanded] = useState(false);
  
  const toggleRemediation = () => {
    setIsRemediationExpanded(!isRemediationExpanded);
  };
  return (
    <div style={{
      background: 'rgb(255, 245, 245)',
      borderRadius: '6px',
      padding: '0.5rem',
      // boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderBottom: '1px solid #f7fafc',
      // border: '1px solid #fed7d7',
      // transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      marginBottom: '1rem'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.75rem'
      }}>
        <div style={{
          background: '#fed7d7',
          borderRadius: '50%',
          width: '2rem',
          height: '2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginTop: '0.125rem'
        }}>
          <span style={{ fontSize: '1rem', color: '#c53030' }}>
            {index + 1}
          </span>
        </div>
        <div style={{ width: '100%' }}>
          {/* Area */}
          <div style={{
            fontWeight: '600',
            color: '#c53030',
            
            fontSize: '1.1rem'
          }}>
            {point.Area}
          </div>
          
          {/* Pain Point */}
          <div style={{
            color: '#2d3748',
            //lineHeight: '1.6',            
          }}>
            {point.PainPoint}
          </div>
          
          {/* Remediation - Collapsible */}
          <div 
            onClick={toggleRemediation}
            style={{
              display: 'flex',
              marginTop: '0.1rem',
              cursor: 'pointer',
              ...(isRemediationExpanded ? {
                //background: '#FFFAF0',
                padding: '0.75rem',
                borderRadius: '8px',
                //borderLeft: '3px solid #DD6B20',
                flexDirection: 'column',
                alignItems: 'stretch'
              } : {
                // More subtle styling when collapsed
                padding: '0.25rem 0',
                alignItems: 'center'
              })
            }}
          >
            <div 
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <span style={{
                fontWeight: '600', 
                color: '#DD6B20',
                fontSize: isRemediationExpanded ? '0.95rem' : '0.85rem',
                display: 'flex',
                alignItems: 'center'
              }}>
                {!isRemediationExpanded && (
                  <span style={{
                    display: 'inline-block',
                    width: '3px',
                    height: '1em',
                    background: '#DD6B20',
                    marginRight: '0.5rem',
                    borderRadius: '1px'
                  }}></span>
                )}
                Suggested Remediation Steps
              </span>
              <span style={{ 
                transform: isRemediationExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease',
                fontSize: '0.9rem',
                color: '#DD6B20',
                opacity: '0.8'
              }}>
                ▼
              </span>
            </div>
            
            {isRemediationExpanded && (
              <div style={{ 
                marginTop: '0.75rem',
                paddingTop: '0.75rem',
                borderTop: '1px solid rgba(221, 107, 32, 0.2)',
                fontSize: '0.75rem'
              }}>
                {point.Remediation}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PainPointCard;
